export enum StoreRegisterType {
	DEFAULT,
	BRANCH,
	PLACE_STORE
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/store-register-type.enum.ts